import { render, staticRenderFns } from "./modalOrdenesAnteriores.vue?vue&type=template&id=54a8e6dd&"
import script from "./modalOrdenesAnteriores.vue?vue&type=script&lang=js&"
export * from "./modalOrdenesAnteriores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports